import { memo } from 'react'

import styles from './AccordionToggle.module.scss'

type Props = {
  isOpen: boolean
  onChange: (isOpen: boolean) => void
  isDisabled?: boolean
}

export const AccordionToggle = memo<Props>(({ isOpen, onChange, isDisabled }) => {
  const toggle = () => {
    onChange(!isOpen)
  }

  return (
    <button disabled={isDisabled} className={styles.button} onClick={toggle}>
      <span className={`${styles.icon} ${isOpen ? styles.isOpen : ''}`}></span>
    </button>
  )
})

AccordionToggle.displayName = 'AccordionToggle'
